import React, { useState } from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import { Redirect } from 'react-router-dom';

import TopBar from "../../components/TopBar";
import Sidebar from "../../components/Sidebar";

import ComplianceGantt from "../../components/Gantt/ComplianceGantt";  // Assuming same Gantt component works
import DashboardComponent from "../../components/Gantt/Dashboard";
import KanBanComponent from "../../components/Gantt/KanBan";
import FindingsComponent from "../../components/Gantt/Findings";


function ComplianceGanttPage(props) {
  const { token, activeDepartmentId, activeDepartment, activeComplianceId } = props;

  const collapsed = false;

  // simple string state (JS-safe). If you're using TS, you can type it later.
  const [viewOption, setViewOption] = useState("Findings"); // "Project" | "Action"

  const handleViewProject = () => setViewOption("Gantt");
  const handleViewAction = () => setViewOption("Action");
  const handleViewKanBan = () => setViewOption("KanBan");
  const handleViewFindings = () => setViewOption("Findings");

  return token ? (
  <div className="flex flex-col w-full h-screen bg-[#F8F8F8] overflow-hidden">
  
    <div className="flex flex-1 w-full overflow-hidden">
     
      {/* Scrollable main content */}
      <div
        id="dashboard-content"
        className={`
          flex flex-col flex-1
          w-full
          overflow-y-auto
          transition-all duration-300
        `}
      >
        {viewOption === "Gantt" ? (
          <div className="overflow-x-auto w-full h-full">
           <ComplianceGantt activeComplianceId={activeComplianceId} />
          </div>
        ) : viewOption === "KanBan" ? (
          <div className="overflow-x-auto w-full h-full">
            <KanBanComponent
              activeDepartmentId={activeDepartmentId}
              activeDepartment={activeDepartment}
              activeComplianceId={activeComplianceId}
              isComp={true}
            />
          </div>
        ) : viewOption === "Findings" ? (
          <div className="overflow-x-auto w-full h-full">
            <FindingsComponent
              activeDepartmentId={activeDepartmentId}
              activeDepartment={activeDepartment}
              viewOption={viewOption}
              onSelectFindings={handleViewFindings}
              onSelectActions={handleViewAction}
              activeComplianceId={activeComplianceId}
              isComp={true}
            />
          </div>
        ) : (
          <div className="overflow-x-auto w-full h-full">
            <DashboardComponent
              activeDepartmentId={activeDepartmentId}
              activeDepartment={activeDepartment}
              viewOption={viewOption}
              onSelectFindings={handleViewFindings}
              onSelectActions={handleViewAction}
              activeComplianceId={activeComplianceId}
              isComp={true}
            />
          </div>
        )}
      </div>
    </div>
  </div>
) : (
  <Redirect to="/login" />
);
}

const mapStateToProps = (state) => {
    return {
        token: state.auth.token,
        activeComplianceId: state.compliance.activeComplianceId,
    };
};

export default compose(connect(mapStateToProps))(ComplianceGanttPage);